import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=3c87cc56&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c87cc56')) {
      api.createRecord('3c87cc56', component.options)
    } else {
      api.reload('3c87cc56', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=3c87cc56&", function () {
      api.rerender('3c87cc56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Auth/Pages/ForgotPassword.vue"
export default component.exports